import ResizeObserver from "resize-observer-polyfill";
import { getEffectTarget } from "@lilib/utils";
import usePersist from "./usePersist";
import useLayoutTargetEffect from "./useLayoutTargetEffect";
function useResizeObserver(target, listener) {
  var handler = usePersist(listener);
  useLayoutTargetEffect(function () {
    var element = getEffectTarget(target);
    if (!element) {
      return;
    }
    var observer = new ResizeObserver(handler);
    observer.observe(element);
    return function () {
      observer.disconnect();
    };
  }, [], [target]);
}
export default useResizeObserver;